import { ref, computed, watch } from 'vue'
import useEventEmitter from '@/_core/hooks/useEventEmitter'
import useApiRequest from '@/_core/hooks/useApiRequest'
import { getLesson } from '@/services/lesson'
import store from '@/store'

export default function ChildBookLessonController () {
  const { $on, $off, $emit } = useEventEmitter()

  // Lesson
  const lesson = ref(null)
  const lessonRequest = useApiRequest(getLesson)
  lessonRequest.$on('success', () => {
    lesson.value = lessonRequest.data
    $emit('requestlesson-success', lessonRequest.data)
  })
  lessonRequest.$on('error', () => {
    $emit('requestlesson-error', lessonRequest.errors)
  })
  const requestLesson = async (lessonId) => {
    await lessonRequest.request(lessonId, store.user.selectedChild.id)
  }
  // subscription on child change
  watch(() => store.user.selectedChild.id, () => { requestLesson(lesson.value.id) })

  // Iframe Listener logic
  const iframeElementRef = ref(null)
  const initIframeListener = (iframeRef) => {
    iframeElementRef.value = iframeRef
    window.addEventListener('message', _onMessage)
  }
  const destroyIframeListener = () => {
    iframeElementRef.value = null
    window.removeEventListener('message', _onMessage)
  }

  const correlationId = ref(null)
  const _setCorrelationId = val => { correlationId.value = val }

  const _onMessage = message => {
    try {
      if (!message?.data) return
      if (!iframeElementRef.value) { console.warn('iframeElementRef is not initialized'); return }
      const parsedData = JSON.parse(message.data)

      switch (parsedData.msgType) {
        case 'eor:container-ready':
          _setCorrelationId(parsedData.correlationId)
          _openTask()
          break

        case 'eor:close':
          $emit('iframe-close-click')
          break

        default:
          break
      }
    } catch (error) {
      console.warn('Error in message:', error)
    }
  }

  const _openTask = () => {
    const message = {
      correlationId: correlationId.value,
      msgType: 'eor:open',
      href: lesson.value.basePlayerUrl,
      state: {
        payload: {
          statement: {
            object: {
              extensions: lesson.value.config
            }
          }
        }
      },
      titleTheme: lesson.value.label
    }
    _postMessage(message)
  }

  const _postMessage = message => {
    iframeElementRef.value.contentWindow.postMessage(JSON.stringify(message), '*')
  }

  // Output.
  const output = {
    lesson,
    requestLesson,
    isLoading: computed(() => lessonRequest.isLoading),
    initIframeListener,
    destroyIframeListener,
    $on,
    $off
  }

  return output
}
